export class AppConfig {
    public environment: string = "";
    public tenantId : string= "";
    public clientId: string = "";
    public baseUrl: string = "";
    public apiUrl: string = "";
    public wellsApiKey: string = "";
    public allowedGroups: string[] = [];
}